import type { AutoIntegrationList } from "@msuite/utils/types";
import { createContext, useContext } from "react";

/** Interface */
interface IAutoIntegrationContext {
	autoIntegrationList: AutoIntegrationList<any>;
}

/** Context */
export const AutoIntegrationContext = createContext<IAutoIntegrationContext>({
	autoIntegrationList: [],
});

/** Hooks */
export function useAutoIntegrationContext() {
	return useContext(AutoIntegrationContext);
}
